import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// components
import FormField from './../Forms/FormField/FormField';
import AddOption from './AddOption/AddOption';
// css
import './AddQuestion.scss';

const AddQuestion = ({
	onChange, question, options, reason, url, onChangeOption, onCreateOption,
	onDestroyOption, onToggleCorrectOption
}) => {
	const [initialCount, setCount] = useState(options.length);
	
	useEffect(() => {
		setCount( options.length );
	},[options.length]);

	const addOption = () => {
		onCreateOption();
	}

	const removeOption = () => {
		onDestroyOption(initialCount - 1);
	}

	const renderOptions = (count) => {
		let rows = [];
		for (var i = 0; i < count; i++) {
			rows.push(
				<AddOption
					key={i}
					currentCount={i}
					maxCount={count}
					onadd={addOption}
					onRemove={removeOption}
					option={options[i]}
					onChangeOption={onChangeOption}
					onToggleCorrectOption={onToggleCorrectOption}
				/>
			);
		}
		return rows;
	}

	return (
		<div className='AddQuestion'>
			<FormField
				label="question"
				name="question"
				type="text"
				multiline
				rows={6}
				placeholder="enter Question"
				value={question}
				onChange= {onChange}
				validate={['required']}
			/>
			{renderOptions(initialCount)}
			{
				options
				&& options.length > 0
				&& options.some((item) => item.option_value !== '')
				&& !options.some((item) => item.correct_answer === 'Y')
				&& <div className="static-note">Please select atleast one correct answer</div>
			}
			<FormField
				label="reason"
				name="reason"
				type="text"
				multiline
				rows={6}
				placeholder="enter reason"
				value={reason}
				onChange= {onChange}
			/>
			<FormField
				label="URL"
				name="url"
				type="text"
				placeholder="enter URL"
				value={url}
				onChange= {onChange}
				validate={['validUrl']}
			/>
		</div>
	);
}

AddQuestion.propTypes = {
	onChange: PropTypes.func,
	question: PropTypes.string,
	options: PropTypes.instanceOf(Array),
	onChangeOption: PropTypes.func,
	onCreateOption: PropTypes.func,
	onDestroyOption: PropTypes.func,
    onToggleCorrectOption: PropTypes.func
};

AddQuestion.defaultProps = {
    onChange: () => {},
	question: 'PropTypes.string',
	options: [],
	onChangeOption: () => {},
	onCreateOption: () => {},
	onDestroyOption: () => {},
    onToggleCorrectOption: () => {}
};

export default AddQuestion;



// WEBPACK FOOTER //
// ./common/AddQuestion/AddQuestion.js